import axios from "./apicall"; // use configured axios client

let queue = [];
let timer = null;
const FLUSH_INTERVAL = 600;
const MAX_BATCH = 100;

const flushLogs = async () => {
  if (!queue.length) {
    timer = null;
    return;
  }

  const batch = [...queue];
  queue = [];

  try {
    await axios.post("/api/v1/logviewer/frontendlogs", batch);
  } catch (err) {
    // prevent retry storms
    console.error("Failed to send batched logs", err);
  }

  timer = null;
};

export const enqueueLog = (log) => {
  if (!log) return;

  queue.push(log);

  if (queue.length > MAX_BATCH) {
    queue = queue.slice(-MAX_BATCH);
  }

  if (!timer) {
    timer = setTimeout(flushLogs, FLUSH_INTERVAL);
  }
};
